import { isNullish } from 'effect/Predicate'

import type { ViewConfig } from '../../schemas/view_config/index.ts'

const SHARED_LINK_PRESET_NAME_PREFIX = '[共有リンク]'

/** [共有リンク] で始まる名前を弾く入力パターン (マッチ = 許可される入力)。 */
export const SHARED_LINK_PRESET_NAME_INPUT_PATTERN = /^(?!\[共有リンク\]).*/v

/** プリセット名先頭の [共有リンク] を取り除く (付いていなければそのまま。null/undefined は undefined を返す)。 */
export const stripSharedLinkPresetNamePrefix = (name: string | null | undefined): string | undefined =>
  name?.replace(/^\[共有リンク\]/v, '')

/** プリセット名が [共有リンク] で始まるかを判定する (undefined は false)。 */
export const isSharedLinkPresetName = (name: string | undefined): boolean =>
  name?.startsWith(SHARED_LINK_PRESET_NAME_PREFIX) ?? false

/** [共有リンク] を先頭に付けたプリセット名を生成する (既に付いていれば二重付与しない)。 */
export const makeSharedLinkPresetName = (name: string | null | undefined): string => {
  if (isNullish(name)) {
    return SHARED_LINK_PRESET_NAME_PREFIX
  }
  return isSharedLinkPresetName(name) ? name : `${SHARED_LINK_PRESET_NAME_PREFIX}${name}`
}

/** view config から [共有リンク] で始まる名前のプリセットを取り除く (sheet / kpiPivot のみ presets を持つ)。 */
export const removeSharedLinkPresetsFromConfig = (config: ViewConfig): ViewConfig => {
  if (config.type === 'sheet') {
    return { ...config, presets: config.presets?.filter((preset) => !isSharedLinkPresetName(preset.name)) }
  }
  if (config.type === 'kpiPivot') {
    return { ...config, presets: config.presets?.filter((preset) => !isSharedLinkPresetName(preset.name)) }
  }
  return config
}
